import React, { useState, useEffect } from 'react';

import { Flag, Build, DriveEta } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { usePrevious } from 'hooks';
import { Grid } from '@material-ui/core';
import { StatisticsCard } from 'components/UI';
import { useStyles } from './StatisticsCard.styled';
import { useDispatch, useSelector } from 'react-redux';
import { SubscriptionsActions } from 'state/modules/subscriptions';

const FleetStatisticsCards = ({ parameters }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const prevCustomParams = usePrevious(parameters);
  const config = useSelector((state) => state.config?.settings);
  const dashboardSettings = config.integrations?.dashboard_settings?.noc;
  const [params, setParams] = useState({
    upcoming: dashboardSettings?.upcoming || 6,
  });
  const prevParams = usePrevious(parameters);

  const { aggregatesTotals } = useSelector((state) => state.subscriptions);

  const getTotals = (params) => {
    dispatch(SubscriptionsActions.fetchAggregatesTotals(params));
  };

  useEffect(() => {
    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      getTotals(params);
    }
  }, [params]); // eslint-disable-line

  useEffect(() => {
    if (JSON.stringify(prevCustomParams) !== JSON.stringify(parameters)) {
      setParams({
        ...params,
        ...parameters,
      });
    }
  }, [parameters, prevCustomParams]); // eslint-disable-line

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <StatisticsCard
          data={{
            inprogress: aggregatesTotals?.utilized || 0,
            available: (aggregatesTotals?.available || 0) + (aggregatesTotals?.utilized || 0),
          }}
          customClasses={{ container: classes.containerThin }}
          status="available"
        >
          <DriveEta />
        </StatisticsCard>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <StatisticsCard
          data={{
            offline: aggregatesTotals?.offline || 0,
            total:
              (aggregatesTotals?.available || 0) +
              (aggregatesTotals?.offline || 0) +
              (aggregatesTotals?.utilized || 0),
          }}
          status="offline"
          customClasses={{ container: classes.containerThin }}
        >
          <Build />
        </StatisticsCard>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={4}>
        <StatisticsCard
          data={{
            in_delivery: aggregatesTotals?.in_delivery || 0,
            in_progress: aggregatesTotals?.in_progress || 0,
            in_return: aggregatesTotals?.in_return || 0,
          }}
          status="inDelivery"
          customClasses={{ container: classes.containerThin }}
        >
          <Flag />
        </StatisticsCard>
      </Grid>
    </Grid>
  );
};

FleetStatisticsCards.propTypes = {
  parameters: PropTypes.object.isRequired,
};

FleetStatisticsCards.defaultProps = {
  pagination: {},
};

export default FleetStatisticsCards;
